import React from "react";
import RecordRouter from './Record/Router';
export { getFields } from './Record/Router';

export default function RecordPmRouter(props) {
    return (
        <RecordRouter {...props} mode='PM' />
    );
};
